import React, { useState, useEffect } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { CONFIG } from '../../../../Config/config'
import { isProduction } from '../../../../Utils/Functions'
import useSmallScreen from './useSmallScreen'

const Captcha = ({ onChangeCaptcha }) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)
  const [isExpired, setExpired] = useState(false)
  const smallScreen = useSmallScreen()

  useEffect(() => {
    setTimeout(() => {
      setIsScriptLoaded(true)
    }, 1000)
  }, [isExpired])

  const onExpired = () => {
    setExpired(true)
    setIsScriptLoaded(false)
    onChangeCaptcha(false)
  }

  return isProduction() ? (
    <div>
      {isScriptLoaded ? (
        <div style={{ display: 'none' }}>
          <ReCAPTCHA
            sitekey={CONFIG.GOOGLE_CAPTCHA}
            style={{
              width: smallScreen ? '100%' : 'auto',
              maxWidth: smallScreen ? '300px' : 'none',
              margin: smallScreen ? '12px auto 32px' : '0',
            }}
          />
        </div>
      ) : null}
      <ReCAPTCHA
        sitekey={CONFIG.GOOGLE_CAPTCHA}
        onChange={onChangeCaptcha}
        onExpired={onExpired}
        style={{
          width: smallScreen ? '100%' : 'auto',
          maxWidth: smallScreen ? '300px' : 'none',
          margin: smallScreen ? '12px auto 32px' : '0',
        }}
      />
    </div>
  ) : null
}

export default Captcha
